import { createTheme } from "@mui/material/styles";

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#CCCCCC",
    },
  },
});

export const primaryColor = "#000000";
export const secondaryColor = "#CCCCCC";

export default theme;
